import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

const SUPPORTED_LANGUAGES = ['en', 'ar', 'fr', 'es', 'ur', 'zh', 'ja', 'tl', 'hi', 'pa'];

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return SUPPORTED_LANGUAGES.includes(saved) ? saved : 'en';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    const rtlLangs = ['ar', 'ur'];
    document.body.setAttribute('dir', rtlLangs.includes(language) ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', language);
    localStorage.setItem('language', language);
  }, [language]);

  const toggleTheme = () => setTheme(t => t === 'light' ? 'dark' : 'light');

  return (
    <AppContext.Provider value={{ theme, toggleTheme, language, setLanguage }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
